import React from 'react';
import {
  FileText, FileCheck, Hash, Calculator, Users, FileBadge,
  Scale, BookOpen, MapPin, ArrowLeftRight,
  Brain, Clock, ShieldCheck, ArrowRight
} from 'lucide-react';
import ServicePageTemplate from '../components/ServicePageTemplate';

const CustomsClearance = () => {
  return (
    <ServicePageTemplate
      heroTitle="Customs Clearance"
      heroImage="/img/customs.jpg"
      slug="customs-clearance"
      introText={[
        'Denver Logistics Private Limited provides efficient and compliant customs clearance services to ensure the smooth movement of your cargo across international borders.',
        'Our experienced team handles all customs procedures, documentation, and regulatory requirements, ensuring timely clearance while minimizing delays and ensuring full compliance with local and international trade regulations.',
      ]}
      services={[
        'Import & Export Customs Clearance',
        'Customs Documentation',
        'HS Code Classification',
        'Duty & Tax Assessment',
        'Liaison with Customs Authorities',
        'Import / Export Permit Assistance',
        'Regulatory Compliance',
        'Customs Consultancy',
        'Cargo Tracking & Status Updates',
        'End-to-End Clearance Support',
      ]}
      serviceIcons={[
        FileText, FileCheck, Hash, Calculator, Users, FileBadge,
        Scale, BookOpen, MapPin, ArrowLeftRight
      ]}
      benefits={[
        { title: 'Expert Knowledge', description: 'Deep expertise in customs regulations and trade compliance.' },
        { title: 'Timely Clearance', description: 'Minimizing delays with efficient documentation and procedures.' },
        { title: 'Full Compliance', description: 'Ensuring compliance with all local and international trade regulations.' },
        { title: 'End-to-End Support', description: 'Complete clearance support from documentation to delivery.' },
      ]}
      benefitIcons={[Brain, Clock, ShieldCheck, ArrowRight]}
      callout={{
        eyebrow: 'COMPLIANT. EFFICIENT. ON TIME.',
        sub: 'On time, every time.',
        ctaLabel: 'TALK TO OUR CUSTOMS TEAM',
      }}
      faq={[
        { q: 'What documents are needed for customs clearance?', a: 'Key documents include the Bill of Lading/Airway Bill, commercial invoice, packing list, certificate of origin, import/export licence (if applicable), and HS code classification. Our team handles all documentation preparation.' },
        { q: 'How long does customs clearance take?', a: 'Standard customs clearance typically takes 1-3 business days. However, timing can vary depending on the cargo type, documentation completeness, and regulatory requirements. We work to minimize delays through proactive documentation and liaison.' },
        { q: 'Do you handle clearance at both origin and destination?', a: 'Yes. We provide customs clearance services at both the origin and destination, ensuring compliant and smooth cargo movement across international borders.' },
      ]}
    />
  );
};

export default CustomsClearance;
